var DataLoader = (function () {
    function DataLoader() {
    }
    DataLoader.loadData = function (assetMap, loader) {
        return new Promise(function (resolve, reject) {
            loader.add(assetMap);
            loader.onError.add(function (_a, loader, resource) {
                var message = _a.message;
                reject(new Error(message + " - " + resource.url));
            });
            loader.load(function () { return resolve(); });
        });
    };
    return DataLoader;
}());
export { DataLoader };
//# sourceMappingURL=data-loader.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@arcade-client/asset-manager/dist/esm/data-loader.js
// module id = null
// module chunks = 